import { callApi } from '../api'

/**
 * The two system-wide fraud switches, shared by the settings tab that changes them and the
 * per-booking tab that has to warn when they are not in their usual state.
 *
 * Both are read from one row that fulfilment reads too, so the screen states what is true rather
 * than what this service happens to be configured with.
 */
export interface FraudSettings {
  /** Whether a waiver may change a booking's outcome. Off until Fraud switches it on. */
  enabled: boolean
  /** Whether a booking with a confirmed related unpaid booking is cancelled automatically. On unless Fraud pauses it. */
  autoRejectEnabled: boolean
  updatedAt: string | null
  updatedBy: string | null
}

const STATUS_PATH = '/bookings/fraud/default-waiver/status'

export const getFraudSettings = () => callApi<FraudSettings>(STATUS_PATH, {}, 'Could not read the fraud settings')

/** Partial: changing one switch must not restate — and so risk changing — the other. */
export const changeFraudSettings = (changes: { enabled?: boolean; autoRejectEnabled?: boolean }) =>
  callApi<FraudSettings>(
    STATUS_PATH,
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(changes),
    },
    'Could not change the setting',
  )

export const WAIVER_REASON_CODES = [
  'balance_cleared',
  'hardship_plan_agreed',
  'default_disputed_resolved',
  'system_error',
]

/**
 * Labels cover more than the dropdown offers: a waiver carried over from the old spreadsheet has
 * to render, but must not be selectable — it records that somebody once ticked a box, which is a
 * weaker claim than any decision made here.
 */
export const WAIVER_REASON_LABELS: Record<string, string> = {
  balance_cleared: 'Balance cleared',
  hardship_plan_agreed: 'Hardship — plan agreed',
  default_disputed_resolved: 'Disputed unpaid booking, resolved for the customer',
  system_error: 'System error',
  migrated_from_sheet: 'Carried over from the old spreadsheet — not re-reviewed',
}
